import React from 'react'
import { ListItem as TestimonialItem } from './list-item'
import { TestiPopup } from './testi-popup'

const FormTestimoni = () => {
  const [popedUpTesti, setPopedUpTesti] = React.useState(false)

  return (
    <div>
      <div className="mb-12">
        <div className="flex justify-between items-center mb-5 lg:mb-8">
          <p className="text-lg font-bold">Testimonials</p>
          <div
            className="text-sm text-primary cursor-pointer whitespace-no-wrap"
            onClick={() => setPopedUpTesti(true)}
          >
            <p className="whitespace-no-wrap underline">See all <span className="hidden lg:inline">testimonials</span></p>
          </div>
        </div>
        <div>
          <div className="mb-5 lg:mb-8 flex justify-between">
            <TestimonialItem
              image="/images/khub_anwar.jpg"
              title="Zulfikar Akbar"
              content="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit."
            />
            <p className="pl-4 lg:pl-10 text-sm underline text-gray-999">Delete</p>
          </div>
          <div className="mb-5 lg:mb-8 flex justify-between">
            <TestimonialItem
              image="/images/khub_anwar.jpg"
              title="Huda Albana"
              content="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit."
            />
            <p className="pl-4 lg:pl-10 text-sm underline text-gray-999">Delete</p>
          </div>
          <div className="mb-5 lg:mb-8 flex justify-between">
            <TestimonialItem
              image="/images/khub_anwar.jpg"
              title="Dannie Zufro"
              content="Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit."
            />
            <p className="pl-4 lg:pl-10 text-sm underline text-gray-999">Delete</p>
          </div>
        </div>
      </div>

      {
        popedUpTesti &&
        <TestiPopup onClose={setPopedUpTesti}/>
      }
    </div>
  )
}

export { FormTestimoni }